var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcLogoClass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 24,
    viewBox: "0 0 86 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h86v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.112)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.637 6.326A6.328 6.328 0 019.644.945 6.301 6.301 0 006.326 0 6.328 6.328 0 000 6.326a6.328 6.328 0 006.326 6.326 6.269 6.269 0 003.318-.944 6.328 6.328 0 01-3.007-5.382z",
    fill: "#06ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.963 0a6.269 6.269 0 00-3.319.945 6.328 6.328 0 013.008 5.381 6.328 6.328 0 01-3.008 5.382c.97.596 2.1.944 3.319.944a6.328 6.328 0 006.326-6.326C19.3 2.834 16.468 0 12.963 0z",
    fill: "#E53639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.665 6.326a6.24 6.24 0 00-.833-3.132A6.29 6.29 0 009.657.944a6.39 6.39 0 00-2.175 2.25 6.333 6.333 0 00-.833 3.132c0 1.143.298 2.2.833 3.132a6.29 6.29 0 002.175 2.25 6.39 6.39 0 002.175-2.25 6.405 6.405 0 00.833-3.132z",
    fill: "#BA0214"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0373F9",
    cx: 26.572,
    cy: 6.326,
    r: 6.326
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.544 8c2.058 0 3.843 1.071 4.683 2.709l-1.953 1.134c-.462-.987-1.491-1.617-2.751-1.617-1.848 0-3.255 1.407-3.255 3.297 0 1.89 1.407 3.297 3.255 3.297 1.26 0 2.289-.651 2.793-1.617l1.953 1.113c-.882 1.659-2.667 2.73-4.725 2.73-3.171 0-5.544-2.415-5.544-5.523C38 10.394 40.373 8 43.544 8zm8.98-5l.104 15.88-2.375.016-.103-15.88L52.525 3zm7.091 5c1.561 0 2.753.579 3.595 1.736l.416-1.467h1.803V18.6h-1.803l-.416-1.486c-.842 1.177-2.034 1.755-3.595 1.755-1.417 0-2.609-.516-3.615-1.57-1.007-1.054-1.5-2.355-1.5-3.864 0-1.529.493-2.81 1.5-3.864C57.006 8.517 58.198 8 59.615 8zm.35 2.128c-.925 0-1.706.31-2.322.951-.616.62-.925 1.405-.925 2.355s.309 1.736.925 2.376c.616.62 1.397.93 2.321.93.925 0 1.705-.31 2.322-.93.616-.64.924-1.425.924-2.376 0-.95-.308-1.735-.924-2.355-.617-.64-1.397-.95-2.322-.95zm11.519 8.918c2.268 0 4.095-1.134 4.095-3.234 0-3.885-5.649-2.73-5.649-4.641 0-.756.714-1.113 1.533-1.113.861 0 1.596.378 1.974 1.197l1.911-1.071C74.613 8.798 73.185 8 71.463 8c-2.142 0-3.843 1.239-3.843 3.213 0 3.759 5.649 2.709 5.649 4.578 0 .84-.777 1.176-1.785 1.176-1.155 0-1.995-.567-2.331-1.512L67.2 16.589c.672 1.512 2.184 2.457 4.284 2.457zm9.8 0c2.268 0 4.095-1.134 4.095-3.234 0-3.885-5.649-2.73-5.649-4.641 0-.756.714-1.113 1.533-1.113.861 0 1.596.378 1.974 1.197l1.911-1.071C84.413 8.798 82.985 8 81.263 8c-2.142 0-3.843 1.239-3.843 3.213 0 3.759 5.649 2.709 5.649 4.578 0 .84-.777 1.176-1.785 1.176-1.155 0-1.995-.567-2.331-1.512L77 16.589c.672 1.512 2.184 2.457 4.284 2.457z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
}

export default __webpack_public_path__ + "dc20c03e.svg";
export { SvgIcLogoClass as ReactComponent };